import { Collapse, Paper, makeStyles } from "@material-ui/core";
import { Group, GroupItem, useFieldLabel } from "ra-friendsofbabba";
import React, { useEffect } from "react";
import { useForm, useFormState } from "react-final-form";

import { DateInput } from "react-admin";
import TextContentInput from "../../component/input/TextContentInput";
import { get } from "lodash";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  foreignOffice: {
    margin: theme.spacing(0, 0, 3, 0),
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: grey[50],
  },
}));
const ActivityInput = ({ type, ...props }) => {
  const formState = useFormState({ subscription: { values: true } });
  const form = useForm();
  const fieldLabel = useFieldLabel({ ...props });
  const classes = useStyles();
  const hasActivity = get(formState.values, `has_${type}_activity`, false);

  useEffect(() => {
    if (!hasActivity) {
      form.batch(() => {
        form.change(`${type}_from_date`, null);
        form.change(`${type}_to_date`, null);
        form.change(`${type}_activity_description`, null);
      });
    }
    if (!hasActivity && type === "foreign") {
      form.change(`foreign_office`, null);
    }
  }, [hasActivity, type, form]);
  return (
    <Collapse in={hasActivity} unmountOnExit>
      <Paper className={classes.paper}>
        <Group fullWidth {...props}>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <DateInput
              label={fieldLabel(`${type}_from_date`)}
              source={`${type}_from_date`}
              disabled
            />
          </GroupItem>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <DateInput
              label={fieldLabel(`${type}_to_date`)}
              source={`${type}_to_date`}
              disabled
            />
          </GroupItem>
        </Group>
        <TextContentInput
          {...props}
          label={fieldLabel(`${type}_activity_description`)}
          source={`${type}_activity_description`}
          fullWidth
          multiline
          maxLength={1000}
          useWorkflow={false}
        />
        {type === "foreign" && (
          <TextContentInput
            {...props}
            className={classes.foreignOffice}
            label={fieldLabel("foreign_office")}
            source="foreign_office"
            fullWidth
            useWorkflow={false}
          />
        )}
      </Paper>
    </Collapse>
  );
};
export default ActivityInput;
